import { useEffect } from 'react';

const useConfirmPageClose = (isUnsafe) => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isUnsafe) {
        event.preventDefault();
        event.returnValue = true;
        return true;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () =>
      window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isUnsafe]);
};

export default useConfirmPageClose;